<template>
	<section class="view-venue-actions button-group pad-left pad-right">
		<ChalkyVenueButtonCall
			class="button-secondary"
			data-analytics-event="place:call"
			size="small"
			v-bind:venueModel="venueModel"
			v-if="$feature('venue_action_call')"
		/>

		<ChalkyVenueButtonWebsite
			class="button-secondary"
			data-analytics-event="place:website"
			size="small"
			v-bind:venueModel="venueModel"
			v-if="$feature('venue_action_website')"
		/>

		<ChalkyVenueButtonDirections
			class="button-secondary"
			data-analytics-event="place:directions"
			size="small"
			v-bind:venueModel="venueModel"
			v-if="$feature('venue_action_directions')"
		/>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Displays action buttons for calling, visiting website, and getting directions to a venue.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Venue
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewVenueActions extends ViewBase {
		/**
		 * The venue model containing contact and location data
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		@Prop({
			default: () => ChalkySticks.Factory.Venue.model(),
		})
		public venueModel!: ChalkySticks.Model.Venue;
	}
</script>

<style lang="scss">
	.view-venue-actions {
		//
	}
</style>
